import { Helper } from '../../../../../classes/helper'
import { useMontage } from '../../../../../context/montage.context'
import { useGLTF } from '@react-three/drei'
import { useRef } from 'react'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'

interface Props {
  type?: string
}

export const MarqueeModelMain = ({ type = '' }: Props): JSX.Element | null => {
  const { measure, roof, marquee } = useMontage()

  const group: any = useRef()
  const { nodes } = useGLTF(`model/marquee/Markise.glb`) as GLTF & any

  return (
    <group
      castShadow
      receiveShadow
      position={[
        Helper.convertToMeter(-16),
        Helper.convertToMeter(measure.userHeight + 10.9),
        Helper.convertToMeter(measure.userWidth / 2),
      ]}
    >
      <group ref={group} dispose={null} castShadow receiveShadow>
        {/* Wall connector */}

        <group
          castShadow
          receiveShadow
          position={[0, Helper.convertToMeter(-0.3 * measure.userAngle), 0]}
          rotation={[0, 0, Helper.convertAngleToRadiant(measure.userAngle!)]}
        >
          {/* Marquee */}
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Markise.geometry}
            material-color={marquee.fabric}
            position={[
              0,
              Helper.convertToMeter(3),
              Helper.convertToMeter(-5.1),
            ]}
            scale={[
              Helper.convertToMeter(measure.userDepth / 2),
              1,
              Helper.convertToMeter(measure.userWidth - 10.9),
            ]}
          >
            <meshPhysicalMaterial color={marquee.fabric} />
          </mesh>

          {/* Font part */}
          <mesh
            geometry={nodes.Markise002.geometry}
            material-color={roof.userColor}
            position={[
              -Helper.convertToMeter(measure.userDepth / 2.2),
              Helper.convertToMeter(3),
              Helper.convertToMeter(-5),
            ]}
            scale={[1, 1, Helper.convertToMeter(measure.userWidth - 10)]}
          >
            <meshPhysicalMaterial color={roof.userColor} />
          </mesh>

          {/* Engine */}
          <mesh
            geometry={nodes.Markise004.geometry}
            material-color={roof.userColor}
            position={[0, Helper.convertToMeter(3), Helper.convertToMeter(-5)]}
            scale={[1, 1, Helper.convertToMeter(measure.userWidth - 10)]}
          >
            <meshPhysicalMaterial color={roof.userColor} />
          </mesh>
        </group>
      </group>
    </group>
  )
}
